import { useState } from 'react';
import Page from '@components/Pages/Page';
import { Pages } from '@lib/constants';
import EditSession from './EditSession';

export const EditSessionPage = () => {
  const [title, setTitle] = useState('Edit Session');
  return (
    <Page
      title={title}
      breadcrumbs={['events', ':event', ':session', 'Edit Session']}
      sectionName="sessions"
      navPhoto={{ image: '/images/sessions/CREATE_EVENT_PHOTO.jpg' }}
      pageId={Pages.SESSION_EDIT}
      requireAuth
    >
      <EditSession setTitle={setTitle} />
    </Page>
  )
};

export default EditSessionPage;
